import { render, staticRenderFns } from "./editDistributorDia.vue?vue&type=template&id=1a1ae938&scoped=true"
import script from "./editDistributorDia.vue?vue&type=script&lang=js"
export * from "./editDistributorDia.vue?vue&type=script&lang=js"
import style0 from "./editDistributorDia.vue?vue&type=style&index=0&id=1a1ae938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ae938",
  null
  
)

export default component.exports